module.exports = __webpack_public_path__ + "static/media/bluetooth.a0de3c2c.svg";